<template>
	<div class="dashboard">
		<!-- Navbar -->
		<Navbar />

		<!-- Page Title and breadnail -->
		<div class="content-header">
			<div class="container">
				<div class="row mb-2">
					<div class="col-sm-11">
						<slot name="breadcrumb"></slot>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-sm-12 page-header">
						<slot name="header"></slot>
					</div>
				</div>
			</div>
		</div>

		<main>
			<!-- Main Content -->
			<slot></slot>
		</main>
	</div>
	<!-- Footer -->
	<div class="footer">
		<Footer />
	</div>
	<!-- Cookie Policy -->
	<CookiePolicy />
</template>

<script>
import Navbar from "@/Frontend/Shared/navbar";
import Footer from "@/Frontend/Shared/footer";
import CookiePolicy from "@/Frontend/Shared/cookiePolicy";
// import Preloader from "@/Frontend/Shared/Preloader";

export default {
	name: "layout",

	mounted() {},
	components: {
		Navbar,
		Footer,
		CookiePolicy,
		// Preloader
	},
};
</script>

<style>
* {
	font-family: "Noto Sans TC", sans-serif;
	box-sizing: border-box;
}

body {
	position: relative;
}
main {
	min-height: 100%;
}
.dashboard {
	min-width: 320px;
	min-height: 90vh;
	height: 100%;
	position: relative;
	overflow: hidden;
	background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
}

.footer {
	position: relative;
	margin-top: 2rem;
	bottom: 0;
	width: 100%;
	padding: 0;
	margin: 0;
}
.content-header {
	margin-top: 90px;
}
.not-found {
	vertical-align: middle;
	text-align: center;
	height: 100%;
}
</style>
